import React from 'react';
import PropTypes from 'prop-types';

import { Link } from 'react-router-dom';
import {
  MdGTranslate,
  MdOutlineWbSunny,
  MdNightlightRound,
  MdLogout,
} from 'react-icons/md';
import {
  LEADERBOARD,
  LEADERBOARD_EN,
  TITLE_FORUM_APPS,
  TITLE_FORUM_APPS_EN,
  URL_HOME,
  URL_LEADERBOARD,
} from '../../utils/common/constant';
import { SettingConsumer } from '../../contexts/settingContext';

import {
  ButtonLogout,
  ButtonToggleLocale,
  ButtonToggleTheme,
  Header, LiHeader, NavHeader, TitleHeader, UlHeader,
} from '../styled';

const ForumHeader = ({ logout, name, logged }) => {
  return (
    <SettingConsumer>
      {
        ({
          locale, toggleLocale, theme, toggleTheme,
        }) => (
          <Header>
            <TitleHeader><Link to={URL_HOME}>{locale === 'id' ? TITLE_FORUM_APPS : TITLE_FORUM_APPS_EN}</Link></TitleHeader>
            <NavHeader>
              <UlHeader>
                {
                    logged
                      ? (
                        <LiHeader>
                          <Link to={URL_LEADERBOARD}>{locale === 'id' ? LEADERBOARD : LEADERBOARD_EN}</Link>
                        </LiHeader>
                      )
                      : ''
                  }
              </UlHeader>
            </NavHeader>
            <ButtonToggleLocale type="button" aria-label="toggle-locale" onClick={toggleLocale}><MdGTranslate /></ButtonToggleLocale>
            <ButtonToggleTheme type="button" aria-label="toggle-theme" onClick={toggleTheme}>{theme === 'dark' ? <MdOutlineWbSunny /> : <MdNightlightRound />}</ButtonToggleTheme>
            {logged ? (
              <ButtonLogout type="button" aria-label="logout" onClick={logout}>
                {name}
                {' '}
                <MdLogout />
              </ButtonLogout>
            ) : ''}
          </Header>
        )
      }
    </SettingConsumer>
  );
};

ForumHeader.defaultProps = {
  logout: null,
  name: '',
  logged: null,
};

ForumHeader.propTypes = {
  logout: PropTypes.func,
  name: PropTypes.string,
  logged: PropTypes.bool,
};

export default ForumHeader;
